import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { of } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { PlanningHasEntity } from '../classes/planning-has-entity.class';
import { EntitiesService } from '../services/entities/entities.service';
import { PlanningHasService } from '../services/planning/planning-has.service';
import { Utils } from '../utils.class';

export interface LocalEntityIsAvailableConfig {
    formGroup: FormGroup;
    beginDateField?: string;
    endDateField?: string;
    planningHasService: PlanningHasService;
    entitiesService: EntitiesService;
    planningId?: number;
}

export const localEntityIsAvailableValidator = (config: LocalEntityIsAvailableConfig) => {
    const {
        formGroup,
        beginDateField = 'begindate',
        endDateField = 'enddate',
        planningHasService,
        entitiesService,
    } = config;

    return (input: FormControl) => {
        if (formGroup.get(beginDateField)?.value && formGroup.get(endDateField)?.value && input.value) {
            const planningHasArray = formGroup.parent?.parent as FormArray;
            const otherFormGroupsPhe = (planningHasArray?.controls ?? [])
                .filter(fg => fg.get('phe') !== formGroup)
                .map(fg => fg.get('phe').value);
            const begindate = Utils.getTimeOrNull(formGroup.get(beginDateField).value);
            const enddate = Utils.getTimeOrNull(formGroup.get(endDateField).value);
            // First get the entities map to check use_once flag
            return entitiesService.getMap().pipe(
                first(),
                switchMap(entitiesMap => {
                    // Check if entity has use_once flag
                    const entity = entitiesMap.get(input.value);
                    if (entity && !entity.use_once) {
                        return of(null);
                    }

                    // Check availability in planning has entries
                    return planningHasService
                        .getFilteredList(
                            Utils.newDate(formGroup.get(beginDateField).value),
                            Utils.newDate(formGroup.get(endDateField).value)
                        )
                        .pipe(
                            first(),
                            map((planningHas: PlanningHasEntity[]) => {
                                let res = false;
                                [
                                    ...(planningHas ?? []).filter(ph => ph.planning_id !== config.planningId),
                                    ...otherFormGroupsPhe,
                                ].forEach(planningHas => {
                                    if (
                                        [
                                            planningHas.entity_id,
                                            planningHas.truck_entity_id,
                                            planningHas.lowloader_entity_id,
                                        ].indexOf(input.value) !== -1
                                    ) {
                                        if (
                                            Utils.getTimeOrNull(planningHas.begindate) < enddate &&
                                            Utils.getTimeOrNull(planningHas.enddate) > begindate
                                        ) {
                                            res = true;
                                        }
                                    }
                                });
                                return res ? { notAvailable: res } : null;
                            })
                        );
                })
            );
        }
        return of(null);
    };
};
